import { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css';  

export default function RegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://nagradjivanje-api.revicon.info/auth/register', { email, password, name });
      alert('Registracija uspješna! Možete se prijaviti.');
      navigate('/');
    } catch {
      alert('Registracija nije uspjela. Pokušajte ponovo.');
    }
  };

  return (
    <div className="page-container">
      <div className="image-container"></div>
      <div className="form-container">
        <div className="login-card">
          <h2>Registracija</h2>
          <form onSubmit={handleRegister}>
            <label>Ime i prezime</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label>Lozinka</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Registruj se</button>
          </form>
          <p>
            Već imate nalog? <Link to="/">Prijavite se</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
